module.exports = __webpack_public_path__ + "static/media/checkbox.adf8d204.svg";